type GetAddressLookupValueParams = {
  answers: string[];
  isUS: boolean;
};

/**
 * Builds the address lookup value string from address field answers.
 * For US addresses, reorders the fields to [City, Street, PostalCode, BuildingName].
 * For UK addresses, maintains the original order.
 */
export const getAddressLookupValue = ({
  answers,
  isUS,
}: GetAddressLookupValueParams): string => {
  if (answers.length === 0) {
    return "";
  }

  // Only reorder for US if we have all 4 expected fields
  const shouldReorder = isUS && answers.length === 4;
  const order = shouldReorder ? [2, 1, 3, 0] : [0, 1, 2, 3];

  return order
    .filter(index => index < answers.length)
    .map(index => answers[index])
    .filter(Boolean)
    .join(", ");
};
